export default "__VITE_ASSET__CUAnyId1__"